/* Copyright (C) 2016 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */
// 03/02/2022 Paul.  Remvoe unused imports. 
//var domQuery              = require('min-dom/lib/query');
//var getBusinessObject     = require('bpmn-js/lib/util/ModelUtil'            ).getBusinessObject;
var cmdHelper             = require('bpmn-js-properties-panel/lib/helper/CmdHelper');
var eventDefinitionHelper = require('bpmn-js-properties-panel/lib/helper/EventDefinitionHelper');
import cron               from './cron';

function ensureNotNull(prop)
{
	if ( !prop )
	{
		throw new Error(prop + ' must be set.');
	}
	return prop;
}

var cronControl = function(options)
{
	var resource   = new cron(options);
	var label      = options.label || resource.id;
	var canBeShown = !!options.show && typeof options.show === 'function';

	var resourceHtml = document.createElement('div');
	let lbl: any = document.createElement('label');
	resourceHtml.appendChild(lbl);
	lbl.for = 'camunda-' + resource.id;
	if ( canBeShown )
		lbl.setAttribute('data-show', 'isShown');
	lbl.appendChild(document.createTextNode(label));

	var pp = document.createElement('div');
	resourceHtml.appendChild(pp);
	pp.className = 'pp-field-wrapper';
	if ( canBeShown )
		pp.setAttribute('data-show', 'isShown');

	resource.Render(pp);
	resource.html = resourceHtml;

	if ( canBeShown )
	{
		resource.isShown = function()
		{
			return options.show.apply(resource, arguments);
		};
	}

	resource.cssClasses = ['pp-textarea'];

	// 06/28/2016 Paul.  The get operation gets from the element, not from the properties control. 
	resource.get = function(element)
	{
		var res = {};
		var prop = ensureNotNull(this.modelProperty);
		
		// Property on the StartEvent element. 
		//var bo = getBusinessObject(element)
		//res[prop] = bo.get(prop);
		//if ( res[prop] === undefined )
		//	res[prop] = '*::*::*::*::*';

		// Property on TimerEventDefinition element. 
		var timerEventDefinition = eventDefinitionHelper.getTimerEventDefinition(element);
		res[prop] = timerEventDefinition.get(prop);
		if ( res[prop] === undefined )
			res[prop] = '*::*::*::*::*';
	
		//console.log('CronEntryFactory get ' + this.modelProperty + ' = ' + res[prop]);
		if ( this.cron == null )
		{
			this.SetCron(res[prop]);
			let txtCamunda: any = document.getElementById('camunda-' + resource.id);
			// 07/04/2016 Paul.  jQuery change/trigger is not working. 
			//$('#' + txtCamunda.id).change();
			//$('#' + txtCamunda.id).trigger('change');
			if ( document.createEvent )
			{
				var evt = document.createEvent('HTMLEvents');
				evt.initEvent('change', true, false);
				txtCamunda.dispatchEvent(evt);
			}
			else if ( txtCamunda.fireEvent )
			{
				txtCamunda.fireEvent('onChange');
			}
		}
		return res;
	}

	// 06/28/2016 Paul.  The set operation sets to the element, not from the properties control. 
	resource.set = function(element, values)
	{
		var res = {};
		var prop = ensureNotNull(this.modelProperty);
		if ( values[prop] !== '' )
		{
			res[prop] = values[prop];
		}
		else
		{
			res[prop] = undefined;
		}
		//console.log('CronEntryFactory set ' + prop + ' = ' + res[prop]);

		// Property on the StartEvent element. 
		//return cmdHelper.updateProperties( element, res );
		
		// Property on TimerEventDefinition element. 
		var timerEventDefinition = eventDefinitionHelper.getTimerEventDefinition(element);
		return cmdHelper.updateBusinessObject(element, timerEventDefinition, res);
	}
	return resource;
};

export default cronControl;

